import axios from 'axios';
import * as Sentry from '@sentry/react';

import properties from '../../../../../../conf/properties';

const reportsBase = properties.reportsServiceEndpoint;

const RCKMSReportsService = (sessionId = false) => {
    const getReportData = async (reportRoute, responseType = 'json') => {
        try {
            const reportData = await axios.get(`${reportsBase}/${reportRoute}/data`, {
                headers: {
                    'X-Cat-Session': sessionId
                },
                responseType
            });

            if (reportData && reportData.status === 200 && reportData.data) {
                return reportData;
            } else {
                throw Error(`RCKMS Reports Service returned status code :${report.status}`);
            }
        } catch (e) {
            Sentry.captureException(e);
            console.warn(e);
            if (e?.response?.status === 400) {
                return e.response;
            }
            // This doesn not current have a mechanism for graceful failure, TODO
            throw Error(e);
        }
    }
    const getReport = async (reportRoute, responseType = 'json') => {
        try {
            const report = await axios.get(`${reportsBase}/${reportRoute}`, {
                headers: {
                    'X-Cat-Session': sessionId
                },
                responseType
            });

            if (report && report.status === 200 && report.data) {
                return report;
            } else {
                throw Error(`RCKMS Reports Service returned status code :${report.status}`);
            }
        } catch (e) {
            Sentry.captureException(e);
            console.warn(e);
            if (e.response.status === 400) {
                return e.response;
            }
            // This doesn not current have a mechanism for graceful failure, TODO
            throw Error(e);
        }
    };

    const generateReport = async (reportRoute) => {
        try {
            // TODO: make a fetch handler for CAT similar to VPAS to DRY this for other requests
            const reportServiceReq = await fetch(`${reportsBase}/${reportRoute}/generate`, {
                method: 'POST',
                mode: 'cors', // default behavior
                cache: 'no-cache', // default behavior
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'X-Cat-Session': sessionId
                },
                body: JSON.stringify({})
            });

            if (!reportServiceReq.ok) {
                throw Error(`RCKMS Reports Service returned status code :${reportServiceReq.status}`);
            }

            const report = await reportServiceReq.json().catch(() => null);

            return report;
        } catch (e) {
            throw Error(e);
        }
    };

    const methods = {
        fetchAllConditionReport: async () => {
            try {
                const { data } = await getReport('all-conditions');

                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        fetchAllJurisdictionStatusReport: async () => {
            try {
                const { data } = await getReport('all-jurisdictions-status');

                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        fetchAllConceptsValueSetsReport: async (ref) => {
            try {
                const { data } = await getReport(`all-concepts-value-sets/${ref ?? 'latest'}`);

                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        generateNewConceptsValueSetsReport: async () => {
            try {
                const { data } = await generateReport('all-concepts-value-sets');

                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        fetchLatestAllConceptsValueSetsMetadata: async () => {
            try {
                const { data } = await getReport('all-concepts-value-sets');

                return data;
            } catch (e) {
                return {
                    status: 500
                };
            }
        },
        fetchAuthoringStatusXlsxReport: async (jurisdictionId) => {
            try {
                const data = await getReport(`authoring-status/${jurisdictionId}`, 'arraybuffer');

                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        fetchConditionDetailsXlsxReport: async (conditionId) => {
            try {
                const data = await getReport(`condition-details/${conditionId}`, 'arraybuffer');

                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        fetchAuthoringStatusData: async (jurisdictionId) => {
            try {
                const { data } = await getReportData(`authoring-status/${jurisdictionId}`, 'json');
                
                return data;
            } catch (e) {
                throw Error(e);
            }
        },
        fetchConditionDetailsData: async (conditionId) => {
            try {
                const { data } = await getReportData(`condition-details/${conditionId}`, 'json');
                
                return data;
            } catch (e) {
                throw Error(e);
            }
        }
    };

    if (!sessionId) {
        // Return err for all child function called
        return Object.keys(methods).reduce(
            (acc, methodName) => ({
                ...acc,
                [methodName]: () =>
                    Promise.reject(new Error('RCKMSReportsService could not be initialized without valid session ID'))
            }),
            {}
        );
    } else {
        return methods;
    }
};

export default RCKMSReportsService;
